/**
 * resolveTenantForWs — derive the active tenant subdomain for the WS
 * connection URL.
 *
 * Every `useWebSocket(...)` call site appends `?tenant=` to
 * the URL alongside `?token=`. The BE `$connect` handler 401s without
 * it. This helper is the single source of truth for the value, sharing
 * the same `parseTenantSubdomain` parser as `apiClient`'s
 * `X-Tenant-Subdomain` HTTP header so the WS handshake speaks for the
 * same tenant as every authenticated REST call from the same tab.
 *
 * SSR-safe: returns `''` when `window` is undefined (vitest jsdom is
 * fine; pre-render is the relevant guard). The empty string is also
 * the fallback for unknown hosts — callers gate their `enabled`
 * boolean on `Boolean(tenant)` so the WS connect is skipped rather
 * than firing a doomed handshake.
 */

import { parseTenantSubdomain } from '@/auth/host-parser'

export function resolveTenantForWs(): string {
  if (typeof window === 'undefined') return ''
  try {
    return parseTenantSubdomain(window.location.host)
  } catch {
    return ''
  }
}
